<template>
    <svg
        width="660"
        height="431"
        viewBox="0 0 660 431"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_1233_6593)">
            <path
                d="M330.5 133.5H648C654.351 133.5 659.5 138.649 659.5 145V270C659.5 276.351 654.351 281.5 648 281.5H330.5V133.5Z"
                fill="var(--et-colors-card-background)"
            />
            <path
                d="M0 145C0 138.373 5.37258 133 12 133H330V282H12C5.37259 282 0 276.627 0 270V145Z"
                fill="var(--et-colors-card-background)"
            />
            <path
                d="M0 294C0 287.373 5.37258 282 12 282H330V431H12C5.37259 431 0 425.627 0 419V294Z"
                fill="var(--et-colors-card-background)"
            />
            <path
                d="M330 282H648C654.627 282 660 287.373 660 294V419C660 425.627 654.627 431 648 431H330V282Z"
                fill="var(--et-colors-card-background)"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="36"
                font-weight="600"
                letter-spacing="-1px"
            >
                <tspan x="276.676" y="58.2001">Pricing</tspan>
            </text>
            <text
                fill="#475467"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="16"
                letter-spacing="0em"
            >
                <tspan x="228.398" y="90.2001">Choose best option for you.</tspan>
            </text>
            <path
                d="M-1 145C-1 137.82 4.8203 132 12 132H330V134H12C5.92487 134 1 138.925 1 145H-1ZM330 283H12C4.8203 283 -1 277.18 -1 270H1C1 276.075 5.92487 281 12 281H330V283ZM12 283C4.8203 283 -1 277.18 -1 270V145C-1 137.82 4.8203 132 12 132V134C5.92487 134 1 138.925 1 145V270C1 276.075 5.92487 281 12 281V283Z"
                fill="var(--et-colors-border)"
            />
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
            >
                <tspan x="16" y="160.4">Basic</tspan>
            </text>
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="24"
                letter-spacing="0em"
            >
                <tspan x="16" y="190.8">$29</tspan>
            </text>
            <path
                d="M296.857 149.429H307.143C310.693 149.429 313.571 152.307 313.571 155.857V166.143C313.571 169.693 310.693 172.571 307.143 172.571H296.857C293.307 172.571 290.429 169.693 290.429 166.143V155.857C290.429 152.307 293.307 149.429 296.857 149.429Z"
                fill="white"
            />
            <path
                d="M330.5 133.5H648C654.351 133.5 659.5 138.649 659.5 145V270C659.5 276.351 654.351 281.5 648 281.5H330.5V133.5Z"
                stroke="var(--et-colors-brand)"
            />
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
            >
                <tspan x="346" y="160.4">Standard</tspan>
            </text>
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="24"
                letter-spacing="0em"
            >
                <tspan x="346" y="190.8">$49</tspan>
            </text>
            <text
                fill="#667085"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
                text-decoration="line-through"
            >
                <tspan x="401" y="186.9">$59</tspan>
            </text>
            <path
                d="M626.857 149.429H637.143C640.693 149.429 643.571 152.307 643.571 155.857V166.143C643.571 169.693 640.693 172.571 637.143 172.571H626.857C623.307 172.571 620.429 169.693 620.429 166.143V155.857C620.429 152.307 623.307 149.429 626.857 149.429Z"
                fill="white"
            />
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
            >
                <tspan x="16" y="309.4">Premium</tspan>
            </text>
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="24"
                letter-spacing="0em"
            >
                <tspan x="16" y="339.8">$69</tspan>
            </text>
            <text
                fill="#667085"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
                text-decoration="line-through"
            >
                <tspan x="71" y="335.9">$79</tspan>
            </text>
            <path
                d="M296.857 298.429H307.143C310.693 298.429 313.571 301.307 313.571 304.857V315.143C313.571 318.693 310.693 321.571 307.143 321.571H296.857C293.307 321.571 290.429 318.693 290.429 315.143V304.857C290.429 301.307 293.307 298.429 296.857 298.429Z"
                fill="white"
            />
            <path
                d="M27.3337 234.667L20.667 241.333M20.667 234.667L27.3337 241.333M27.3337 254.667L20.667 261.333M20.667 254.667L27.3337 261.333M357.334 254.667L350.667 261.333M350.667 254.667L357.334 261.333M27.3337 403.667L20.667 410.333M20.667 403.667L27.3337 410.333"
                stroke="#D92D20"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
            >
                <tspan x="346" y="309.4">Enterprise</tspan>
            </text>
            <text
                fill="var(--et-colors-card-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="24"
                letter-spacing="0em"
            >
                <tspan x="346" y="339.8">$89</tspan>
            </text>
            <text
                fill="#667085"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="12"
                letter-spacing="0em"
                text-decoration="line-through"
            >
                <tspan x="401" y="335.9">$99</tspan>
            </text>
            <path
                d="M626.857 298.429H637.143C640.693 298.429 643.571 301.307 643.571 304.857V315.143C643.571 318.693 640.693 321.571 637.143 321.571H626.857C623.307 321.571 620.429 318.693 620.429 315.143V304.857C620.429 301.307 623.307 298.429 626.857 298.429Z"
                fill="white"
            />
            <path
                d="M626.857 298.429H637.143C640.693 298.429 643.571 301.307 643.571 304.857V315.143C643.571 318.693 640.693 321.571 637.143 321.571H626.857C623.307 321.571 620.429 318.693 620.429 315.143V304.857C620.429 301.307 623.307 298.429 626.857 298.429Z"
                stroke="#D0D5DD"
                stroke-width="0.857143"
            />
            <path
                d="M301.723 158.509C300.881 158.494 300.039 158.513 299.199 158.566C298.557 158.606 298.047 159.117 297.979 159.757C297.907 160.43 297.839 161.123 297.839 161.832C297.839 162.542 297.907 163.236 297.979 163.908C298.048 164.547 298.558 165.06 299.199 165.1C300.531 165.182 301.804 165.182 303.137 165.1C303.779 165.06 304.289 164.547 304.357 163.908C304.429 163.235 304.497 162.542 304.497 161.832C304.497 161.646 304.492 161.462 304.484 161.278M302.167 160.79L305.997 156.959M306.014 159.658C306.121 158.579 306.121 157.987 306.014 156.955C304.982 156.847 304.389 156.847 303.311 156.955M631.723 158.509C630.881 158.494 630.039 158.513 629.199 158.566C628.557 158.606 628.047 159.117 627.979 159.757C627.907 160.43 627.839 161.123 627.839 161.832C627.839 162.542 627.907 163.236 627.979 163.908C628.048 164.547 628.558 165.06 629.199 165.1C630.531 165.182 631.804 165.182 633.137 165.1C633.779 165.06 634.289 164.547 634.357 163.908C634.429 163.235 634.497 162.542 634.497 161.832C634.497 161.646 634.492 161.462 634.484 161.278M632.167 160.79L635.997 156.959M636.014 159.658C636.121 158.579 636.121 157.987 636.014 156.955C634.982 156.847 634.389 156.847 633.311 156.955M301.723 307.509C300.881 307.494 300.039 307.513 299.199 307.566C298.557 307.606 298.047 308.117 297.979 308.757C297.907 309.43 297.839 310.123 297.839 310.832C297.839 311.542 297.907 312.236 297.979 312.908C298.048 313.547 298.558 314.06 299.199 314.1C300.531 314.182 301.804 314.182 303.137 314.1C303.779 314.06 304.289 313.547 304.357 312.908C304.429 312.235 304.497 311.542 304.497 310.832C304.497 310.646 304.492 310.462 304.484 310.278M302.167 309.79L305.997 305.959M306.014 308.658C306.121 307.579 306.121 306.987 306.014 305.955C304.982 305.847 304.389 305.847 303.311 305.955M631.723 307.509C630.881 307.494 630.039 307.513 629.199 307.566C628.557 307.606 628.047 308.117 627.979 308.757C627.907 309.43 627.839 310.123 627.839 310.832C627.839 311.542 627.907 312.236 627.979 312.908C628.048 313.547 628.558 314.06 629.199 314.1C630.531 314.182 631.804 314.182 633.137 314.1C633.779 314.06 634.289 313.547 634.357 312.908C634.429 312.235 634.497 311.542 634.497 310.832C634.497 310.646 634.492 310.462 634.484 310.278M632.167 309.79L635.997 305.959M636.014 308.658C636.121 307.579 636.121 306.987 636.014 305.955C634.982 305.847 634.389 305.847 633.311 305.955"
                stroke="#344054"
                stroke-width="0.964286"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M29.3337 214L22.0003 221.333L18.667 218M359.334 214L352 221.333L348.667 218M359.334 234L352 241.333L348.667 238M29.3337 363L22.0003 370.333L18.667 367M29.3337 383L22.0003 390.333L18.667 387M359.334 363L352 370.333L348.667 367M359.334 383L352 390.333L348.667 387M359.334 403L352 410.333L348.667 407"
                stroke="#079455"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M192 212H42C38.6863 212 36 214.686 36 218C36 221.314 38.6863 224 42 224H192C195.314 224 198 221.314 198 218C198 214.686 195.314 212 192 212Z"
                fill="#F2F4F7"
            />
            <path
                d="M114 232H42C38.6863 232 36 234.686 36 238C36 241.314 38.6863 244 42 244H114C117.314 244 120 241.314 120 238C120 234.686 117.314 232 114 232Z"
                fill="#F2F4F7"
            />
            <path
                d="M137 252H42C38.6863 252 36 254.686 36 258C36 261.314 38.6863 264 42 264H137C140.314 264 143 261.314 143 258C143 254.686 140.314 252 137 252Z"
                fill="#F2F4F7"
            />
            <path
                d="M522 212H372C368.686 212 366 214.686 366 218C366 221.314 368.686 224 372 224H522C525.314 224 528 221.314 528 218C528 214.686 525.314 212 522 212Z"
                fill="#F2F4F7"
            />
            <path
                d="M444 232H372C368.686 232 366 234.686 366 238C366 241.314 368.686 244 372 244H444C447.314 244 450 241.314 450 238C450 234.686 447.314 232 444 232Z"
                fill="#F2F4F7"
            />
            <path
                d="M467 252H372C368.686 252 366 254.686 366 258C366 261.314 368.686 264 372 264H467C470.314 264 473 261.314 473 258C473 254.686 470.314 252 467 252Z"
                fill="#F2F4F7"
            />
            <path
                d="M192 361H42C38.6863 361 36 363.686 36 367C36 370.314 38.6863 373 42 373H192C195.314 373 198 370.314 198 367C198 363.686 195.314 361 192 361Z"
                fill="#F2F4F7"
            />
            <path
                d="M114 381H42C38.6863 381 36 383.686 36 387C36 390.314 38.6863 393 42 393H114C117.314 393 120 390.314 120 387C120 383.686 117.314 381 114 381Z"
                fill="#F2F4F7"
            />
            <path
                d="M137 401H42C38.6863 401 36 403.686 36 407C36 410.314 38.6863 413 42 413H137C140.314 413 143 410.314 143 407C143 403.686 140.314 401 137 401Z"
                fill="#F2F4F7"
            />
            <path
                d="M522 361H372C368.686 361 366 363.686 366 367C366 370.314 368.686 373 372 373H522C525.314 373 528 370.314 528 367C528 363.686 525.314 361 522 361Z"
                fill="#F2F4F7"
            />
            <path
                d="M444 381H372C368.686 381 366 383.686 366 387C366 390.314 368.686 393 372 393H444C447.314 393 450 390.314 450 387C450 383.686 447.314 381 444 381Z"
                fill="#F2F4F7"
            />
            <path
                d="M467 401H372C368.686 401 366 403.686 366 407C366 410.314 368.686 413 372 413H467C470.314 413 473 410.314 473 407C473 403.686 470.314 401 467 401Z"
                fill="#F2F4F7"
            />
        </g>
        <defs>
            <clipPath id="clip0_1233_6593">
                <rect width="660" height="431" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
